import { cn } from "@/lib/utils";
import { METRIC_BADGE_TONES } from "./metric-badge-tones";

const MetricCodeBadge = ({ code, category, className }) => {
  const categoryStyle =
    METRIC_BADGE_TONES[category]?.code || METRIC_BADGE_TONES.General.code;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-xl border px-2 py-0.5 text-xs shrink-0",
        categoryStyle,
        className,
      )}
    >
      {code}
    </span>
  );
};

export default MetricCodeBadge;
